import { Component, Input } from '@angular/core';
import { LoadingController, NavController, NavParams } from 'ionic-angular';
import { IngredientCompCreateSelectIngPage } from "../../ingredient-comp-create/ingredient-comp-create-select-ing/ingredient-comp-create-select-ing";
import { Globals } from "../../../../globals";
import { IngredientsServices } from '../../services';

/**
 * Generated class for the IngredientViewFoodcostPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-ingredient-view-foodcost',
  templateUrl: 'ingredient-view-foodcost.html',
})
export class IngredientViewFoodcostPage {
  @Input() ingredient: any;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public globals: Globals,
    public ingredientsServices: IngredientsServices) {
  }

  editCIngredients() {
    this.navCtrl.push(IngredientCompCreateSelectIngPage, {
      update_state: true,
      ingredient_uid: this.ingredient.UID,
      ingredients: this.ingredient,
      ingredient_name: this.ingredient.name,
      ingredient_measurement: this.ingredient.measurement
    });
  }

}


// WEBPACK FOOTER //
// ./src/pages/ingredients/ingredient-view/ingredient-view-foodcost/ingredient-view-foodcost.ts